import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/Reveal";
import api from "../lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="pt-40 text-center text-muted-foreground">Post not found. <Link to="/blog" className="text-accent">Back to blog</Link></div>;
  if (!post) return <div className="pt-40 text-center text-muted-foreground">Loading…</div>;

  return (
    <article className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6">
        <Link to="/blog" className="inline-flex items-center gap-2 text-accent mb-8 hover:gap-3 transition-all"><ArrowLeft size={18} /> Back to Journal</Link>
        <Reveal>
          <p className="label-caps text-accent">{new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })} · {post.author}</p>
          <h1 className="font-serif-display text-4xl md:text-5xl mt-4 leading-tight">{post.title}</h1>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="max-w-5xl mx-auto px-6 mt-10">
        <img src={post.cover_image} alt={post.title} className="rounded-3xl w-full object-cover aspect-[16/9]" />
      </Reveal>
      <div className="max-w-3xl mx-auto px-6 mt-12 space-y-6 text-lg text-muted-foreground leading-relaxed">
        {post.content.split("\n\n").map((para, i) => (
          <p key={i}>{para}</p>
        ))}
      </div>
    </article>
  );
}
